import { SwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  displayErrorMessage,
  displaySuccess,
  displayInfo,
} from 'Helpers/FacetNotificationManager';
import Select from 'Components/UI/BehavioralFormElement/Select';
import RadioGroup from 'Components/UI/BehavioralFormElement/RadioGroup';
import { HouseholdStatusSelect } from 'Components/UI/Select';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog';

const getFieldDefByName = (template, name) => {
  let def = (template || []).filter(a => a.name === name);
  def = def.length ? def[0] : { options: [] };
  return def;
};

const getOptions = (template, name) => {
  const def = getFieldDefByName(template, name);
  const options = (def.options || []).map(o => ({
    id: o.id,
    value: o.prompt,
  }));

  options.unshift({ id: 0, value: '' });

  return options;
};

const getDependentOptions = (template, name, val) => {
  const def = getFieldDefByName(template, name);
  const options = (def.options || [])
    .filter(
      o => o.depends && o.depends.length && o.depends.some(v => v === val),
    )
    .map(o => ({
      id: o.id,
      value: o.prompt,
    }));
  options.unshift({ id: 0, value: '' });
  return options;
};

class HouseholdSectionMemberLegacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceId: 0,
      sourceTypeId: 0,
      sourcePartnerId: 0,
      sourceOptions: [{ id: 0, value: '' }],
      sourceTypeOptions: [{ id: 0, value: '' }],
      sourcePartnerOptions: [{ id: 0, value: '' }],
      communicationType: '',
      statusId: 0,
      showStatusChangeConfirmation: false,
      statusTemp: 0,
      refreshCounter: 0,
    };
    this.updateSource = this.updateSource.bind(this);
    this.handleUpdateHousehold = this.handleUpdateHousehold.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleChurnSave = this.handleChurnSave.bind(this);
  }

  componentDidMount() {
    const { household, householdResource } = this.props;

    this.settingUpOptions(householdResource.meta().export(), household);
  }

  componentDidUpdate(prevProps) {
    const { household, householdResource } = this.props;

    if (household.id !== prevProps.household.id) {
      this.settingUpOptions(householdResource.meta().export(), household);
    }
  }

  settingUpOptions(meta, household) {
    this.setState({
      sourceId: household.sourceId || 0,
      sourceTypeId: household.sourceTypeId || 0,
      communicationType: household.communicationType,
      sourcePartnerId: household.sourcePartnerId || 0,
      statusId: household.statusId,
      sourceOptions: getOptions(meta.template, 'sourceId'),
      sourceTypeOptions: getDependentOptions(
        meta.template,
        'sourceTypeId',
        household.sourceId.toString(),
      ),
      sourcePartnerOptions: getDependentOptions(
        meta.template,
        'sourcePartnerId',
        household.sourceId.toString(),
      ),
    });
  }

  updateSource(val) {
    const { householdResource } = this.props;

    const meta = householdResource.meta().export();

    const sourceTypeOptions = getDependentOptions(
      meta.template,
      'sourceTypeId',
      val,
    );
    const sourcePartnerOptions = getDependentOptions(
      meta.template,
      'sourcePartnerId',
      val,
    );
    this.setState(
      {
        sourceId: val,
        sourceTypeId: 0,
        sourcePartnerId: 0,
        sourceTypeOptions,
        sourcePartnerOptions,
      },
      displayInfo('You must now set the source type now'),
    );
  }

  handleUpdate(property, val) {
    const { householdResource, updateHousehold } = this.props;

    if (val !== householdResource.attr(property)) {
      const req = householdResource.copy().attr(property, val.toString());
      updateHousehold(req.export()).then(() => {
        displaySuccess(`Updated ${property} to ${val}`);
      });
    }
  }

  handleUpdateHousehold(property) {
    const { household, updateHousehold } = this.props;
    const { getHousehold } = this.context;

    const {
      sourceId,
      sourceTypeId,
      sourcePartnerId,
      communicationType,
      statusId,
    } = this.state;

    getHousehold(household.id)
      .then((res) => {
        const updatedHousehold = {
          id: household.id,
          type: 'household',
          attributes: {
            ...res.data.attributes,
            sourceId: sourceId.toString(),
            sourceTypeId: sourceTypeId > 0 ? sourceTypeId.toString() : '',
            communicationType,
            statusId: statusId.toString(),
            churnCategory: statusId === 4 ? household.churnCategory : '',
            churnSubCategory: statusId === 4 ? household.churnSubCategory : '',
            churnDescription: statusId === 4 ? household.churnDescription : '',
            churnDate: statusId === 4 ? household.churnDate : '',
            leadPlannerId: household.leadPlannerId.toString(),
            sourcePartnerId:
              sourcePartnerId > 0 ? sourcePartnerId.toString() : '',
            csManagerId: household.csManagerId.toString(),
          },
        };

        updateHousehold(updatedHousehold)
          .then(() => {
            displaySuccess(`Client ${property} updated`);
            if (property === 'status') {
              household.statusId = statusId;
            }
          })
          .catch(({ response }) => {
            if (response && response.body) {
              if (response.body.status === 409) {
                // TODO: Remove once better error messages are implemented
                displayErrorMessage(response);
              } else if (response.body.errors) {
                displayErrorMessage(response.body.errors, response.body.errors);
              }
            }
          });
      })
      .catch(({ response }) => {
        if (response && response.body) {
          if (response.body.errors) {
            displayErrorMessage(response.body.errors, response.body.errors);
          }
        }
      });
  }

  handleChurnSave() {
    // const { refreshHousehold } = this.props;
    const { refreshCounter } = this.state;
    // refreshHousehold();
    this.setState({
      showStatusChangeConfirmation: false,
      statusTemp: 0,
      // This is a hack to force the churn commentary form to rerender when the modal closes
      // Both the modal and the standalone form us SimpleHouseholdContext, but the form doesn't rerender when
      // the modal calls updateHousehold
      refreshCounter: refreshCounter + 1,
    });
  }

  closeModal() {
    this.setState({
      showStatusChangeConfirmation: false,
      statusTemp: 0,
    });
  }

  render() {
    const {
      sourceId,
      sourceTypeId,
      sourcePartnerId,
      sourceOptions,
      sourceTypeOptions,
      communicationType,
      statusId,
      sourcePartnerOptions,
      showStatusChangeConfirmation,
      statusTemp,
    } = this.state;
    const { householdResource } = this.props;

    const HouseholdStatusSelector = HouseholdStatusSelect(
      householdResource.meta().export(),
    );

    return (
      <div>
        <div className="section-row-a">
          <div>Status</div>
          <div>
            <HouseholdStatusSelector
              value={statusId}
              onChange={(_, val) => {
                this.setState({
                  showStatusChangeConfirmation: true,
                  statusTemp: val,
                });
              }}
            />
          </div>
          {
                showStatusChangeConfirmation && (
                <ConfirmationDialog
                  message="This will update the client's status."
                  onConfirm={() => {
                    this.setState(
                      {
                        statusId: statusTemp,
                        showStatusChangeConfirmation: false,
                      },
                      () => {
                        return this.handleUpdateHousehold('status');
                      },
                    );
                  }}
                  onCancel={() => this.closeModal()}
                />
                )
            }
        </div>
        <div className="section-row-a">
          <div>Partner</div>
          <div>
            <Select
              options={sourceOptions}
              value={sourceId.toString()}
              onChange={(_, val) => this.updateSource(val)}
            />
          </div>
        </div>
        <div className="section-row-a">
          <div>Type</div>
          <div>
            <Select
              options={sourceTypeOptions}
              value={sourceTypeId.toString()}
              onChange={(_, val) => this.setState({ sourceTypeId: val }, () => {
                return this.handleUpdateHousehold('source type', val);
              })
                  }
            />
          </div>
        </div>
        {sourcePartnerOptions.length > 1 && (
          <div className="section-row-a">
            <div>Contact</div>
            <div>
              <Select
                options={sourcePartnerOptions}
                value={sourcePartnerId.toString()}
                onChange={(_, val) => this.setState({ sourcePartnerId: val }, () => {
                  return this.handleUpdateHousehold('source partner', val);
                })
                      }
              />
            </div>
          </div>
        )}
        <div className="section-row-a">
          <div>Offering</div>
          <div>
            <RadioGroup
              onChange={(_, val) => this.handleUpdate('communicationType', val)}
              value={communicationType}
              name="offering"
              options={[
                { id: 'offline', text: 'Offline' },
                { id: 'online', text: 'Online' },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

HouseholdSectionMemberLegacy.contextType = SwaggerlessContext;

HouseholdSectionMemberLegacy.propTypes = {
  household: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  updateHousehold: PropTypes.func.isRequired,
};

export default HouseholdSectionMemberLegacy;
